import ButtonLoader from "../loaders/ButtonLoader";
import React, { useState, useEffect } from "react";

type ButtonType = {
    text: string;
    onClick?: () => Promise<void> | void;
    isActive: boolean;
    ref?: React.Ref<HTMLButtonElement>;
    isButtonLoading?: boolean;
    buttonColor?: string;
    borderColor?: string;
    className?: string;
    textSize?: string;
};

const LightCustomButton = React.forwardRef<HTMLButtonElement, ButtonType>(
    (props, ref) => {
        const [isButtonDisabled, setIsButtonDisabled] = useState(false);

        const handleVerification = async () => {
            if (props.onClick) {
                setIsButtonDisabled(true);
                try {
                    await props.onClick();
                } catch (error) {
                    console.error("Error occurred:", error);
                } finally {
                    setIsButtonDisabled(false);
                }
            }
        };

        const activeButtonColor = props.buttonColor || "bg-bg-button-secondary";
        const activeBorderColor =
            props.borderColor || "border-border-button-secondary";
        const textSize = props.textSize || "14px";

        useEffect(() => {
            if (props.isButtonLoading) {
                setIsButtonDisabled(true);
            } else {
                setIsButtonDisabled(false);
            }
        }, [props.isButtonLoading]);

        return (
            <div>
                {props.isActive ? (
                    props.isButtonLoading ? (
                        <button
                            ref={ref}
                            className={`${activeButtonColor} border ${activeBorderColor} font-semibold py-[4px] px-[12px] flex items-center justify-center disabled rounded-lg ${props.className}`}
                            onClick={handleVerification}
                            disabled={isButtonDisabled}
                        >
                            <ButtonLoader />
                        </button>
                    ) : (
                        <button
                            ref={ref}
                            className={`flex-1 ${activeButtonColor} border ${activeBorderColor} text-[${textSize}] text-text-base font-semibold py-[4px] px-[12px] rounded-lg ${props.className}`}
                            onClick={handleVerification}
                            disabled={isButtonDisabled}
                        >
                            {props.text}
                        </button>
                    )
                ) : (
                    <button
                        ref={ref}
                        className={`flex-1 bg-bg-disabled border border-border-disabled text-[${textSize}] font-semibold py-[4px] px-[12px] rounded-lg text-text-disabled ${props.className}`}
                        disabled
                    >
                        {props.text}
                    </button>
                )}
            </div>
        );
    }
);

export default LightCustomButton;
